import {Box, Stack} from "@mui/material";
import SystemIndex from "assets/icons/system/system.index";
import {OverdueItemType} from "types/ActivityFeedTypes";
import TimestampTypo from "components/Typography/TimestampTypo";
import {enActivityFeedLabel} from "constants/index";
import {formatDateTimeFirestoreDate} from "screens/utility/formatDateTimeFirestoreDate";
import theme from "theme/theme";
import ItemContainer from "components/ActivityFeed/ItemContainer";

interface OverdueItemProps {
  item: OverdueItemType
}

function OverdueItem(props: OverdueItemProps) {
  const {item} = props;
  const { timestamp} = item;
  const {date, time} = formatDateTimeFirestoreDate(timestamp);

  return (
    <ItemContainer>
      <Box width={24} height={24}>
        <SystemIndex.SystemIcons.Calendar stroke={theme.palette.error.main} width={20} height={20}/>
      </Box>
      <Stack direction="column">
        {enActivityFeedLabel.overdue}
        <TimestampTypo>{`${date} ${time}`}</TimestampTypo>
      </Stack>
    </ItemContainer>
  );
}

export default OverdueItem;
